import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./dashboard.css";

const AllMeeting = () => {
  return <div style={{ marginTop: "15%" }}></div>;
};
export default AllMeeting;
